<script>
import options from './MemberListOverlayCancerforum.options'
export default options
</script>

<template>
  <div class="kb-member-list-overlay__content-wrapper" ref="overlayRef">
    <article class="kb-member-list-overlay" :class="{ 'kb-member-list-overlay--submitting': isSubmitting }">
      <div class="kb-member-list-overlay__wrapper">
        <h2 class="kb-member-list-overlay__title">
          {{ getLabel('accordionTitle', [memberListData.totalHits?.toString()]) }}
        </h2>

        <template v-for="(member, index) in memberListData.memberList" :key="index">
          <div class="kb-member-list-overlay">
            <h3 class="kb-member-list-overlay__member">
              <svg viewBox="0 0 705 11" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M705 1H2a1 1 0 0 0-1 1v9" stroke="#BFBFB7" />
              </svg>
              <button :id="`acc-member${member.id}`" class="kb-member-list-overlay__member-button" :aria-controls="`acc-content${member.id}`" aria-expanded="false"
                v-on:click="toggleAccordion" @keydown.tab="tabTrap">
                <figure class="kb-image-module kb-image-module--1-1 kb-member-list-overlay__member-profile-img">
                  <div class="kb-image-module__image-container">
                    <picture class="kb-image-module__image">
                      <img :src="member.memberImgSrc" :alt="member.memberImgAlt" />
                    </picture>
                  </div>
                </figure>
                <p class="kb-member-list-overlay__member-name">
                  {{ member.memberName }}
                  <div class="kb-member-overlay__member-roles-wrapper">
                    <template v-for="(memberRole, index) in member.memberRoles" :key="index">
                      <span class="kb-member-overlay__member-role">
                        {{ memberRole }}
                      </span>
                    </template>
                  </div>
                </p>
                <div class="kb-member-list-overlay__member-chevron kb-ui-icon kb-ui-icon--ui-chevron-down"></div>
              </button>
            </h3>
            <div class="kb-member-list-overlay__content" :id="`acc-content${member.id}`" role="region"
              :aria-labelledby="`acc-member${member.id}`">
              <article class="kb-member-list-overlay__content-member-details">
                <p class="kb-member-list-overlay__content-member-details-profile-text">
                  <template v-for="(line, index) in formatNewlines(member.memberProfileText)" :key="index">
                    <br v-if="index > 0">{{ line }}
                  </template>
                </p>
                <ul class="kb-member-list-overlay__content-member-details-list">
                <template v-for="(memberDetails, index) in member.details" :key="index">
                    <li>
                      <p> {{ memberDetails.label }}</p>
                      <p> {{ memberDetails.detail }}</p>
                    </li>
                  </template>
                </ul>
                <a :href="member.answerLink" class="kb-button kb-button--full-color" tabindex="-1"> {{ getLabel('writeMessageButtonText') }}</a>
              </article>
            </div>
          </div>

        </template>
        <div class="kb-member-list-overlay__actions-wrapper">
          <div class="kb-member-list-overlay__show-more" v-if="showLoadMoreMembersButton">
            <button class="kb-member-list-overlay__show-more-button kb-button kb-button--full-color-spot" @click="loadMore()" @keydown.tab="tabTrap">
                {{ getLabel("showMoreButtonText") }}
            </button>
          </div>
        </div>
      </div>
      
      <template v-if="isSubmitting">
        <div class="kb-spinner-overlay">
          <div class="kb-spinner-overlay__spinner kb-spinner-overlay__spinner--sticky"></div>
        </div>
      </template>
    </article>
  </div>
</template>
